import { z } from '../utils/zod-extend'
import { idSchema } from './id.type'

export const actionType = [
  'popupView', // ポップアップの表示（ポップアップの数分）
  'popupClick', // ポップアップのクリック
  'campaignClick', // キャンペーンのクリック
  'questionView', // 質問の表示
  'thanksView', // サンクスページの表示
  'thanksLinkClick', // サンクスページ内のリンク押下
  'userCreate', // ユーザ作成
] as const

export const thanksLinkType = [
  'paragraphContent', // 本文
  'image', // 画像リンク
] as const

export const userActionHistoryDetailJson = z.object({
  popupName: z.string().optional(),
  campaignName: z.string().optional(),
  surveyName: z.string().optional(),
  launcherContentName: z.string().optional(),
  questionName: z.string().optional(),
  thanksLinkType: z.enum(thanksLinkType).optional(),
  thanksLinkUrl: z.string().optional(),
})
export type UserActionHistoryDetailJson = z.infer<typeof userActionHistoryDetailJson>

export const createUserActionHistorySchema = z.object({
  id: idSchema.optional(), // 重複送信を防ぐために、client側でulidを生成して送信させる
  accountId: idSchema,
  url: z.string(),
  actionType: z.enum(actionType),
  popupId: idSchema.optional(),
  campaignId: idSchema.optional(),
  surveyId: idSchema.optional(),
  launcherContentId: idSchema.optional(),
  questionId: idSchema.optional(),
  detailsJson: userActionHistoryDetailJson.optional(),
})
export type CreateUserActionHistoryValues = z.infer<typeof createUserActionHistorySchema>
